module.exports = __webpack_public_path__ + "8b0fdcc1e1957c5622b07c8413b1d25a.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/maja-wichrowska.jpg
// module id = 446
// module chunks = 0